/** Настройки откатов. */

import type { ReactNode } from 'react';

import { Field, TextInput } from '../../components/ui.tsx';
import { Section, type SettingsTabProps } from './shared.tsx';

export function RollbacksTab({ draft, update }: SettingsTabProps): ReactNode {
  return (
    <Section title="Личные каналы">
      <Field label="Попыток разослать откаты" hint="После исчерпания бот перестаёт пытаться">
        <TextInput
          type="number"
          min={1}
          max={100}
          value={draft.rollbackMaxAttempts}
          onChange={(event) => {
            update('rollbackMaxAttempts', Number.parseInt(event.target.value, 10) || 1);
          }}
        />
      </Field>
    </Section>
  );
}
